import z from 'zod';

export const macroTypeEnum = z.enum([ 'materialLookup' ]);

export const baseMacroCfgSchema = z.object({
    type: z.string(),
    id: z.string(),
    name: z.string().optional(),
});
